import { render, staticRenderFns } from "./Rating_History.vue?vue&type=template&id=138b061a&scoped=true"
import script from "./Rating_History.vue?vue&type=script&lang=js"
export * from "./Rating_History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b061a",
  null
  
)

export default component.exports